import Vue from 'vue'
import api from 'api'

const state = {
    instanceId: 0,
    currentStep: 'FIRST_STEP',
    currentPosition: 2,
    currentPatient: null,
    selectedAnswer: null,
    nbPatients: 10,
    satisfactionSurveyEnabled: true,
    answerMissing: false,
    nextButtonDisabled: false,
    stepExplanations: {
        "FIRST_STEP": "",
        "CRITIC_STEP": "",
        "SECOND_STEP": "",
        "SATISFACTION_SURVEY": ""
    },
    criterias: [
    ],
    questions: [
    ],
    answers: {
        "FIRST_SECOND_STEP": [
        "Oui",
        "Non",
        "Non applicable",
        ],
        "CRITIC_STEP": [],
        "SATISFACTION_SURVEY": {
            "APPRECIATION": [
            "-2",
            "-1",
            "+1",
            "+2"
            ],
            "YES_NO": [
            "OUI",
            "NON"
            ]
        }
    },
    userAnswers: {
        "FIRST_STEP": [],
        "CRITIC_STEP": [],
        "SECOND_STEP": [],
        "SATISFACTION_SURVEY": []
    },
    modalStartTraining: false,
    userInstances: []
};

const getters = {
    currentStepExplanation: state => {
        return state.stepExplanations[state.currentStep];
    },
    criteriaQuestionTotalNumber: state => {
        if (state.currentStep != 'SATISFACTION_SURVEY')
            return state.criterias.length;
        return state.questions.length;
    },
    currentCriteriaQuestionText: state => {
        if (state.currentStep != 'SATISFACTION_SURVEY')
            return state.criterias[state.currentPosition - 1];
        return state.questions[state.currentPosition - 1];
    },
    getCurrentStepAnswers: state => {
        if (state.currentStep == 'FIRST_STEP' || state.currentStep == 'SECOND_STEP')
            return state.answers['FIRST_SECOND_STEP'];
        if (state.currentStep == "SATISFACTION_SURVEY")
            return state.answers[state.currentStep][state.questions[state.currentPosition - 1].answerType]
        return state.answers[state.currentStep];
    },
    completedAnswers: state => {
        if (state.currentStep == 'FIRST_STEP' || state.currentStep == 'SECOND_STEP')  {
            let cnt = 0;
            for (let patientAnswers in state.userAnswers[state.currentStep]) {
                for (let answer in state.userAnswers[state.currentStep][patientAnswers])  {
                    if (state.userAnswers[state.currentStep][patientAnswers][answer] != -1) {
                        ++cnt;
                    }
                }
            }
            return cnt;
        }
        return state.userAnswers[state.currentStep].filter(answer => answer != -1 ? true : false).length;
    },
    totalAnswersNumber: state => {
        let coef = 1;
        if (state.currentStep == 'SATISFACTION_SURVEY')
            return state.questions.length;
        if (state.currentStep == 'FIRST_STEP' || state.currentStep == 'SECOND_STEP')
            coef = state.nbPatients;
        return state.criterias.length * coef;
    },
    nbPatientsFilled: state => {
        if (state.currentStep == 'FIRST_STEP' || state.currentStep == 'SECOND_STEP')  {
            return state.userAnswers[state.currentStep].filter(patientAnswers => patientAnswers.filter(answer => answer != -1 ? 1 : 0).length == state.criterias.length ? 1 : 0).length;
        }
        return 0;
    }
};

const mutations = {
    CURRENT_STEP_UPDATED(state, newStep) {
        state.currentStep = newStep;
    },
    CURRENT_PATIENT_UPDATED(state, newPatient) {
        state.currentPatient = newPatient;
    },
    SELECTED_ANSWER_UPDATED(state, newAnswer) {
        state.selectedAnswer = newAnswer;
        state.answerMissing = false;
        if (state.currentStep == "FIRST_STEP" || state.currentStep == "SECOND_STEP")  {
            if (!state.userAnswers[state.currentStep][state.currentPatient - 1])  {
                Vue.set(state.userAnswers[state.currentStep], state.currentPatient - 1, []);
            }
            Vue.set(state.userAnswers[state.currentStep][state.currentPatient - 1], state.currentPosition - 1, state.selectedAnswer);
        }
        else  {
            Vue.set(state.userAnswers[state.currentStep], state.currentPosition - 1, state.selectedAnswer);
        }
    },
    CURRENT_POSITION_UPDATED(state, {newStep, newPosition})  {
        state.currentPosition = newPosition;
        if (newStep == 'FIRST_STEP' || newStep == 'SECOND_STEP')  {
            state.selectedAnswer = state.userAnswers[newStep][state.currentPatient - 1] == undefined || state.userAnswers[newStep][state.currentPatient - 1][state.currentPosition - 1] == undefined ? -1 : state.userAnswers[newStep][state.currentPatient - 1][state.currentPosition - 1];
        }
        else if (newStep != 'END'){
            state.selectedAnswer = state.userAnswers[newStep][state.currentPosition - 1] == undefined ? -1 : state.userAnswers[newStep][state.currentPosition - 1];
        }
        else  {
            state.selectedAnswer = -1;
        }
        state.answerMissing = false;
    },
    INIT_INSTANCE(state, {instance, template, answers})  {
        state.instanceId = instance.id;
        state.nbPatients = template.nbPatients;
        state.stepExplanations = template.explanations;
        Vue.set(state.answers, 'CRITIC_STEP', template.criticResponses);
        state.satisfactionSurveyEnabled = template.satisfactionSurvey != 'NONE' ? true : false;
        state.criterias = template.criterias;
        state.questions = template.surveyQuestions;
        state.currentStep = instance.currentStep.step;
        state.currentPosition = state.currentStep != 'SATISFACTION_SURVEY' ? instance.currentCriteria.criteriaPosition : instance.currentSurveyQuestion.questionPosition;
        state.currentPatient = instance.currentCriteria.patientNumber;
        state.userAnswers = answers;
        if (state.currentStep == 'FIRST_STEP' || state.currentStep == 'SECOND_STEP')  {
            state.selectedAnswer = state.userAnswers[state.currentStep][state.currentPatient - 1][state.currentPosition - 1];
        }
        else if (state.currentStep != 'END') {
            state.selectedAnswer = state.userAnswers[state.currentStep][state.currentPosition - 1];
        }
    },
    ANSWER_MISSING_UPDATED(state, newValue) {
        if (newValue == true)
            state.nextButtonDisabled = false;
        state.answerMissing = newValue;
    },
    NEXT_BUTTON_DISABLED_UPDATED(state, newValue) {
        state.nextButtonDisabled = newValue;
    },
    DISPLAY_MODAL_START_TRAINING(state, newValue) {
        state.modalStartTraining = newValue;
    },
    USER_INSTANCES_UPDATED(state, newValue)    {
        state.userInstances = newValue;
    }
};

const actions = {
    getInstance({rootState}, {instanceId, callbacks}) {
        api.getInstance(rootState, instanceId, callbacks);
    },
    endStep({rootState, state, commit}, {nextStep, nextPosition, nextPatient}) {
        let successCallback = ()    => {
            commit('CURRENT_STEP_UPDATED', nextStep);
            if (nextPosition)  {
                commit('CURRENT_PATIENT_UPDATED', nextPatient);
                commit('CURRENT_POSITION_UPDATED', {newStep: nextStep, newPosition: nextPosition});
            }
            commit('NEXT_BUTTON_DISABLED_UPDATED', false);
        };

        api.endStep(rootState, state.instanceId, state.currentStep, nextStep, {success: successCallback});

        if (nextStep == "SECOND_STEP") {
            commit('DISPLAY_MODAL_START_TRAINING', true);
        }
    },
    setCriteriaAnswer({rootState, state, commit, dispatch}, {nextCriteriaPosition, nextStep, nextPatient}) {
        let successCallback = ()    => {
            commit('CURRENT_PATIENT_UPDATED', nextPatient);
            commit('CURRENT_POSITION_UPDATED', {newStep: nextStep, newPosition: nextCriteriaPosition});
            if (nextStep != state.currentStep)  {
                dispatch("endStep", {
                                    nextCriteriaPosition: nextCriteriaPosition,
                                    nextStep: nextStep,
                                    nextPatient: nextPatient
                                });
            }
            else    {
                commit('NEXT_BUTTON_DISABLED_UPDATED', false);
            }
        };

        api.setCriteriaAnswer(rootState,
                            state.instanceId,
                            state.selectedAnswer,
                            nextCriteriaPosition,
                            nextStep,
                            nextPatient,
                            state.currentPatient,
                            state.currentStep,
                            {success: successCallback});
    },
    setSurveyQuestionAnswer({rootState, state, commit, dispatch}, {nextSurveyQuestionPosition, nextStep, nextPatient}) {
        let last = state.currentPosition == state.questions.length;

        let successCallback = ()    => {
            if (!last)  {
                commit('CURRENT_POSITION_UPDATED', {newStep: nextStep, newPosition: nextSurveyQuestionPosition});
            }
            if (nextStep != state.currentStep) {
                dispatch("endStep", {
                                    nextSurveyQuestionPosition: nextSurveyQuestionPosition,
                                    nextStep: nextStep,
                                    nextPatient: nextPatient
                                });
            }
            else    {
                commit('NEXT_BUTTON_DISABLED_UPDATED', false);
            }
        };

        api.setSurveyQuestionAnswer(rootState, state.instanceId, state.selectedAnswer, nextSurveyQuestionPosition, last, {success: successCallback});
    },
    changeStep({commit, dispatch}, newStep) {
        let data = {
            nextPosition: 1,
            nextStep: newStep,
            nextPatient: newStep == "FIRST_STEP" || newStep == "SECOND_STEP" ? 1 : 0
        };
        dispatch('endStep', data);
    },
    changePatient({dispatch, commit, getters}, params) {
        if (params.newPatient > state.userAnswers[state.currentStep].length && params.button == false)
            return;

        let data = {
            nextCriteriaPosition: params.newPatient < state.currentPatient && params.button ? state.criterias.length : 1,
            nextStep: state.currentStep,
            nextPatient: params.newPatient
        };
        if (params.button && params.newPatient > state.currentPatient)  {
            if ((state.selectedAnswer < 0 || state.selectedAnswer > (getters.getCurrentStepAnswers.length - 1)) && params.button) {
                commit('ANSWER_MISSING_UPDATED', true)
                return;
            }
            dispatch('setCriteriaAnswer', data);
        }
        else  {
            commit('CURRENT_PATIENT_UPDATED', data.nextPatient);
            commit('CURRENT_POSITION_UPDATED', {newStep: state.currentStep, newPosition: data.nextCriteriaPosition});
        }
    },
    changeAnswer({commit}, newAnswer) {
        commit('SELECTED_ANSWER_UPDATED', newAnswer);
    },
    changePosition({dispatch, commit, getters}, newPosition) {
        if (newPosition > state.currentPosition) {
            if (state.selectedAnswer < 0 || state.selectedAnswer > (getters.getCurrentStepAnswers.length - 1)) {
                commit('ANSWER_MISSING_UPDATED', true)
                return;
            }
            if (state.currentStep != 'SATISFACTION_SURVEY') {
                let data = {
                    nextCriteriaPosition: newPosition,
                    nextStep: state.currentStep,
                    nextPatient: state.currentStep == 'FIRST_STEP' || state.currentStep == 'SECOND_STEP' ? state.currentPatient : 0
                };
                dispatch('setCriteriaAnswer', data);
            }
            else    {
                let data = {
                    nextSurveyQuestionPosition: newPosition,
                    nextStep: state.currentStep,
                    nextPatient: state.currentStep == 'FIRST_STEP' || state.currentStep == 'SECOND_STEP' ? state.currentPatient : 0
                };
                dispatch('setSurveyQuestionAnswer', data);
            }
        }
        else  {
            commit('CURRENT_PATIENT_UPDATED', state.currentStep == 'FIRST_STEP' || state.currentStep == 'SECOND_STEP' ? state.currentPatient : 0);
            commit('CURRENT_POSITION_UPDATED', {newStep: state.currentStep, newPosition: newPosition});
        }
    },
    previousStep({commit, dispatch, getters}, newStep) {
        let isFirstOrSecondStep = newStep == "FIRST_STEP" || newStep == "SECOND_STEP";
        let data = {
            nextPosition: isFirstOrSecondStep ? state.userAnswers[newStep][state.userAnswers[newStep].length - 1].length: state.criterias.length,
            nextStep: newStep,
            nextPatient: isFirstOrSecondStep ? state.userAnswers[newStep].length : 0
        };
        dispatch('endStep', data);
    },
    finishStep({commit, dispatch, getters}, newStep) {
        if (state.selectedAnswer < 0 || state.selectedAnswer > (getters.getCurrentStepAnswers.length - 1)) {
            commit('ANSWER_MISSING_UPDATED', true)
            return;
        }
        if (state.currentStep != 'SATISFACTION_SURVEY') {
            let data = {
                nextCriteriaPosition: 1,
                nextStep: newStep,
                nextPatient: newStep == 'FIRST_STEP' || newStep == 'SECOND_STEP' ? 1 : 0
            };
            dispatch('setCriteriaAnswer', data);
        }
        else    {
            let data = {
                nextSurveyQuestionPosition: 1,
                nextStep: newStep,
                nextPatient: newStep == 'FIRST_STEP' || newStep == 'SECOND_STEP' ? 1 : 0
            };
            dispatch('setSurveyQuestionAnswer', data);
        }
    },
    failInitInstance({commit})  {
    },
    toggleDisplay({commit}, newValue) {
        commit('DISPLAY_MODAL_START_TRAINING', newValue);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
